export default "__VITE_ASSET__DtfYeZK5__"